function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState } from 'react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import { Tooltip } from 'reactstrap';
import { getHashLeft, hasValue, formatIndicatorValue, roundIndicatorValue } from './../utils';
import useStore from './../store';

var getRobotext = function getRobotext(context) {
  var roboKey = context.diff === 0 ? 'RAW_ROBO_NO_DIFF' : 'RAW_ROBO_DIFF';
  return i18n.translate(roboKey, context);
};

var IndicatorRawScale = function IndicatorRawScale(_ref) {
  var indicator = _ref.indicator,
      value = _ref.value,
      region = _ref.region,
      props = _objectWithoutPropertiesLoose(_ref, ["indicator", "value", "region"]); // console.log('IndicatorRawScale, ', props)


  var interactionsMobile = useStore(function (state) {
    return state.interactionsMobile;
  }); // do not render if no value

  if (!hasValue(value)) return null;
  var high_is_good = !!Number(indicator.highisgood);
  var min = Number(indicator.min);
  var max = Number(indicator.max);
  var mean = Number(indicator.mean);
  var rightVal = !!high_is_good ? max : min;
  var leftVal = !!high_is_good ? min : max;
  var diff = roundIndicatorValue(value, indicator) - roundIndicatorValue(mean, indicator);
  var diffValue = formatIndicatorValue(Math.abs(diff), indicator);
  var diffLabel = diff > 0 ? 'higher' : 'lower';
  var rightLabel = formatIndicatorValue(rightVal, indicator);
  var leftLabel = formatIndicatorValue(leftVal, indicator);
  var valueLabel = formatIndicatorValue(value, indicator);
  var meanLabel = formatIndicatorValue(mean, indicator);
  var percentFromLeft = getHashLeft(roundIndicatorValue(value, indicator), !!high_is_good ? min : max, !!high_is_good ? max : min);
  var meanPercentFromLeft = getHashLeft(roundIndicatorValue(mean, indicator), !!high_is_good ? min : max, !!high_is_good ? max : min); // Preserve: For checking a particular indicator, if there are issues with its presentation.
  // if (props.indicator.variable === 'Tot_EITC') {
  //   console.log(
  //     'Tot_EITC',
  //     meanPercentFromLeft,
  //     meanPercentFromLeft > 90 &&
  //       String(meanPercentFromLeft).length > 2,
  //     meanPercentFromLeft < 10 &&
  //       String(meanPercentFromLeft).length > 2,
  //   )
  // }
  // Manage tooltip state.

  var _useState = useState(false),
      tooltipOpen = _useState[0],
      setTooltipOpen = _useState[1];

  var toggle = function toggle() {
    return setTooltipOpen(!tooltipOpen);
  };

  var robotext = getRobotext({
    name: i18n.translate(indicator.id),
    value: value,
    mean: mean,
    valueLabel: valueLabel,
    meanLabel: meanLabel,
    diff: diff,
    diffValue: diffValue,
    diffLabel: diffLabel,
    region: region
  });
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("p", {
    className: "gotham12",
    dangerouslySetInnerHTML: {
      __html: robotext
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: clsx('linear-scale', "" + indicator.id)
  }, /*#__PURE__*/React.createElement("div", {
    className: "linear-scale-bar"
  }), /*#__PURE__*/React.createElement("div", {
    className: "linear-scale-value hash-group",
    style: {
      left: percentFromLeft + "%"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: clsx('label', 'gotham14', 'grey2', {
      'justify-right': percentFromLeft > 92 && String(valueLabel).length > 3,
      'justify-left': percentFromLeft < 8 && String(valueLabel).length > 3
    })
  }, valueLabel), /*#__PURE__*/React.createElement("div", {
    className: "linear-scale-hash-value"
  })), /*#__PURE__*/React.createElement("div", {
    className: "linear-scale-mean hash-group",
    style: {
      left: meanPercentFromLeft + "%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "linear-scale-hash-mean"
  }), /*#__PURE__*/React.createElement("span", {
    id: "linear_scale_tooltip_target_" + indicator.id,
    className: clsx('label', 'gotham12', 'grey2', {
      'justify-right': meanPercentFromLeft > 90,
      'justify-left': meanPercentFromLeft < 10
    }),
    href: "#"
  }, meanLabel), /*#__PURE__*/React.createElement(Tooltip, {
    placement: !!interactionsMobile ? 'auto' : 'right',
    boundariesElement: "window",
    isOpen: tooltipOpen,
    target: "linear_scale_tooltip_target_" + indicator.id,
    toggle: toggle
  }, i18n.translate("LINEAR_SCALE_MEAN_DESC"))), /*#__PURE__*/React.createElement("div", {
    className: "linear-scale-labels"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label gotham12 grey2"
  }, leftLabel), /*#__PURE__*/React.createElement("span", {
    className: "label gotham12 grey2"
  }, rightLabel))));
};

export default IndicatorRawScale;